import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_FR_P3B } from './seo-comparison-p3b.fr';


const SITEMINDER_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io vs SiteMinder',
  heroSubtitle: 'SiteMinder est un gestionnaire de canaux australien fond\u00e9 en 2006 ax\u00e9 sur la distribution OTA. HotelStack.io offre une plateforme compl\u00e8te de gestion h\u00f4teli\u00e8re avec 36 modules incluant la gestion des canaux, le PMS, la restauration, les outils de revenus et plus \u2014 le tout \u00e0 un prix inf\u00e9rieur.',
  overviewComparison: [
    { label: 'Type de plateforme', hotelstack: 'HMS tout-en-un (36 modules)', competitor: 'Gestionnaire de canaux + compl\u00e9ments' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 99 $+/mois' },
    { label: 'PMS int\u00e9gr\u00e9', hotelstack: 'PMS complet inclus', competitor: 'Little Hotelier (s\u00e9par\u00e9)' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Gestion des revenus', hotelstack: 'Avanc\u00e9e (int\u00e9gr\u00e9e)', competitor: 'R\u00e8gles de rendement basiques' },
    { label: 'Moteur de r\u00e9servation', hotelstack: 'BookMyRoom.io (gratuit)', competitor: 'TheBookingButton (compl\u00e9ment)' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: false },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: 'Via Little Hotelier' },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: false },
        { name: 'Gestion du folio client', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: false },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribution et gestion des canaux',
      features: [
        { name: 'Gestionnaire de canaux (100+ OTA)', hotelstack: true, competitor: true },
        { name: 'Connectivit\u00e9 GDS', hotelstack: true, competitor: true },
        { name: 'Int\u00e9gration m\u00e9tarecherche', hotelstack: true, competitor: true },
        { name: 'Surveillance de la parit\u00e9 tarifaire', hotelstack: true, competitor: true },
        { name: 'Moteur de r\u00e9servation directe', hotelstack: true, competitor: 'Module compl\u00e9mentaire' },
      ],
    },
    {
      category: 'Gestion des revenus',
      features: [
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: 'Basique' },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: false },
        { name: 'Analyses RevPAR', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Clients et op\u00e9rations',
      features: [
        { name: 'Profils clients 360 degr\u00e9s', hotelstack: true, competitor: false },
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: false },
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-\u00e9tablissements et conformit\u00e9',
      features: [
        { name: 'Tableau de bord de la cha\u00eene', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Analyses inter-\u00e9tablissements', hotelstack: true, competitor: false },
        { name: 'Facturation multidevise', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Conformit\u00e9 fiscale r\u00e9gionale', hotelstack: true, competitor: false },
        { name: 'Gestion du programme de fid\u00e9lit\u00e9', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: false },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: 'Les 36 modules inclus \u2014 PMS, gestionnaire de canaux, moteur de r\u00e9servation, restauration, gestion des revenus. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration gratuites.',
    competitorNote: 'Gestionnaire de canaux \u00e0 partir de 99 $+/mois. PMS (Little Hotelier) et moteur de r\u00e9servation (TheBookingButton) sont des produits s\u00e9par\u00e9s avec des frais s\u00e9par\u00e9s. Aucun module de restauration ou op\u00e9rationnel.',
  },
  advantages: [
    'Plateforme compl\u00e8te tout-en-un avec 36 modules contre l\'approche gestionnaire de canaux uniquement de SiteMinder',
    'PMS complet int\u00e9gr\u00e9 \u2014 pas besoin d\'acheter Little Hotelier s\u00e9par\u00e9ment pour la gestion de l\'\u00e9tablissement',
    'Restauration, POS, service en chambre et gestion de cuisine inclus sans co\u00fbt suppl\u00e9mentaire',
    'Gestion avanc\u00e9e des revenus avec tarification dynamique, pr\u00e9vision et simulateurs hypoth\u00e9tiques',
    'CRM client avec profils 360 degr\u00e9s, programmes de fid\u00e9lit\u00e9 et communications automatis\u00e9es',
    'Outils op\u00e9rationnels : m\u00e9nage, maintenance, planification du personnel tous int\u00e9gr\u00e9s',
    'Prix de d\u00e9part inf\u00e9rieur (49 $ contre 99 $+) avec beaucoup plus de fonctionnalit\u00e9s incluses',
    'Int\u00e9gration et migration de donn\u00e9es gratuites avec support d\u00e9di\u00e9 24h/24 7j/7',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'SiteMinder excelle en tant que gestionnaire de canaux autonome avec une forte connectivit\u00e9 OTA construite sur pr\u00e8s de deux d\u00e9cennies. Cependant, ce n\'est pas une plateforme compl\u00e8te de gestion h\u00f4teli\u00e8re. HotelStack.io inclut tout ce que SiteMinder offre en distribution plus un PMS complet, la restauration/POS, la gestion des revenus, le CRM client et plus de 25 modules suppl\u00e9mentaires \u2014 le tout dans un seul abonnement \u00e0 un prix inf\u00e9rieur.',
    bestFor: [
      'H\u00f4tels souhaitant une plateforme unique au lieu d\'assembler SiteMinder + PMS + POS',
      '\u00c9tablissements n\u00e9cessitant PMS complet, restauration et outils op\u00e9rationnels au-del\u00e0 de la gestion des canaux',
      'H\u00f4tels souhaitant une gestion avanc\u00e9e des revenus et pr\u00e9vision de la demande',
      'Petits \u00e9tablissements trouvant SiteMinder trop co\u00fbteux pour la distribution seule',
      'Cha\u00eenes multi-\u00e9tablissements n\u00e9cessitant une gestion centralis\u00e9e de toutes les op\u00e9rations',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de SiteMinder vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration transf\u00e8re vos connexions OTA, plans tarifaires et donn\u00e9es de r\u00e9servation. HotelStack.io se connecte aux m\u00eames 100+ OTA que SiteMinder prend en charge. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans interruption.' },
    { question: 'HotelStack.io \u00e9gale-t-il les capacit\u00e9s de gestion des canaux de SiteMinder ?', answer: 'Oui. HotelStack.io inclut un gestionnaire de canaux complet connect\u00e9 \u00e0 100+ OTA, GDS via Amadeus et Sabre, et les plateformes de m\u00e9tarecherche. La surveillance de la parit\u00e9 tarifaire et la synchronisation d\'inventaire en temps r\u00e9el sont des fonctionnalit\u00e9s standard incluses dans chaque plan.' },
    { question: 'Pourquoi choisir HotelStack.io plut\u00f4t que SiteMinder + Little Hotelier ?', answer: 'L\'achat s\u00e9par\u00e9 de SiteMinder (gestionnaire de canaux) plus Little Hotelier (PMS) plus TheBookingButton (moteur de r\u00e9servation) co\u00fbte beaucoup plus que HotelStack.io tout en manquant de restauration, gestion des revenus, planification du personnel et plus de 20 autres modules que HotelStack.io inclut.' },
    { question: 'HotelStack.io convient-il aux petits \u00e9tablissements utilisant actuellement SiteMinder ?', answer: 'Absolument. Notre plan Starter \u00e0 49 $/mois inclut les 36 modules sans restriction de fonctionnalit\u00e9s. Les petits \u00e9tablissements obtiennent une plateforme de gestion compl\u00e8te au lieu d\'un simple gestionnaire de canaux, \u00e0 un co\u00fbt total inf\u00e9rieur \u00e0 SiteMinder seul.' },
  ],
};

const ROOMRACCOON_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io vs RoomRaccoon',
  heroSubtitle: 'RoomRaccoon est un HMS n\u00e9erlandais pilot\u00e9 par l\'IA ciblant les h\u00f4tels boutique et petits. HotelStack.io \u00e9volue du boutique \u00e0 l\'entreprise avec 36 modules, une gestion avanc\u00e9e des revenus, la restauration/POS compl\u00e8te et le support multi-\u00e9tablissements \u2014 le tout \u00e0 des tarifs comp\u00e9titifs.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules int\u00e9gr\u00e9s', competitor: '10+ modules' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 79 $+/mois' },
    { label: 'Segment cible', hotelstack: 'PME \u00e0 entreprise', competitor: 'Boutique / Petits h\u00f4tels' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Multi-\u00e9tablissements', hotelstack: 'Gestion de cha\u00eene compl\u00e8te', competitor: 'Limit\u00e9' },
    { label: 'Port\u00e9e mondiale', hotelstack: 'Plus de 40 pays', competitor: 'Principalement Europe' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Gestion du folio client', hotelstack: true, competitor: true },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Revenus et distribution',
      features: [
        { name: 'Gestionnaire de canaux (100+ OTA)', hotelstack: true, competitor: 'Moins d\'OTA' },
        { name: 'Gestion du rendement par IA', hotelstack: true, competitor: true },
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: 'Basique' },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Gestion des clients',
      features: [
        { name: 'Profils clients 360 degr\u00e9s', hotelstack: true, competitor: 'Basique' },
        { name: 'Gestion du programme de fid\u00e9lit\u00e9', hotelstack: true, competitor: false },
        { name: 'Automatisation de la communication client', hotelstack: true, competitor: true },
        { name: 'Analyses des d\u00e9penses clients', hotelstack: true, competitor: false },
        { name: 'T\u00e9l\u00e9chargement et v\u00e9rification d\'identit\u00e9', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Restauration et op\u00e9rations',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: true },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Entreprise et multi-\u00e9tablissements',
      features: [
        { name: 'Tableau de bord de la cha\u00eene', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Analyses inter-\u00e9tablissements', hotelstack: true, competitor: false },
        { name: 'Gestion centralis\u00e9e des tarifs', hotelstack: true, competitor: false },
        { name: 'Application des standards de marque', hotelstack: true, competitor: false },
        { name: 'Super-admin plateforme', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Résilience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arrière-plan à la reconnexion', hotelstack: true, competitor: false },
        { name: 'Réconciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'Réception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'Réservation de groupe avec listes de chambres', hotelstack: true, competitor: 'Limité' },
        { name: 'Rapports de créances et de production', hotelstack: true, competitor: false },
        { name: 'Réservations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Congés et présences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: 'Les 36 modules inclus. \u00c9volue du boutique 10 chambres \u00e0 l\'entreprise 500+ chambres. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration gratuites.',
    competitorNote: 'Tarification par paliers \u00e0 partir de 79 EUR+/mois. Fonctionnalit\u00e9s avanc\u00e9es verrouill\u00e9es derri\u00e8re les paliers sup\u00e9rieurs. Capacit\u00e9s entreprise et multi-\u00e9tablissements limit\u00e9es.',
  },
  advantages: [
    'Plus de trois fois les modules (36 contre 10+) sans fonctionnalit\u00e9s verrouill\u00e9es derri\u00e8re des paliers premium',
    '\u00c9volue du boutique \u00e0 l\'entreprise \u2014 RoomRaccoon est limit\u00e9 aux petits/moyens \u00e9tablissements',
    'Module complet de restauration avec POS, service en chambre et gestion de cuisine inclus',
    'Gestion compl\u00e8te de cha\u00eene multi-\u00e9tablissements avec analyses centralis\u00e9es et distribution tarifaire',
    'Gestion avanc\u00e9e des revenus au-del\u00e0 du rendement IA basique \u2014 inclut pr\u00e9vision et simulateurs',
    'Gestion du programme de fid\u00e9lit\u00e9 pour la r\u00e9tention des clients et la croissance des r\u00e9servations r\u00e9p\u00e9t\u00e9es',
    'Port\u00e9e mondiale dans plus de 40 pays contre la focalisation europ\u00e9enne de RoomRaccoon',
    'Gestion du personnel avec planification, paie et suivi des performances inclus',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'RoomRaccoon est un choix solide pour les petits h\u00f4tels boutique europ\u00e9ens cherchant un PMS pilot\u00e9 par l\'IA avec une interface moderne. Cependant, il manque de profondeur, d\'\u00e9volutivit\u00e9 et d\'ampleur op\u00e9rationnelle dont les \u00e9tablissements en croissance ont besoin. HotelStack.io offre tout ce que RoomRaccoon propose plus la restauration/POS, la gestion multi-\u00e9tablissements entreprise, les outils de revenus avanc\u00e9s et la conformit\u00e9 mondiale \u2014 ce qui en fait l\'investissement \u00e0 long terme le plus solide.',
    bestFor: [
      'H\u00f4tels boutique souhaitant des fonctionnalit\u00e9s entreprise sans tarification entreprise',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et gestion de cuisine dans leur HMS',
      'H\u00f4tels pr\u00e9voyant de passer d\'un \u00e9tablissement unique \u00e0 une cha\u00eene multi-\u00e9tablissements',
      '\u00c9tablissements hors d\'Europe n\u00e9cessitant conformit\u00e9 et distribution mondiales',
      'H\u00f4tels souhaitant une gestion avanc\u00e9e des revenus au-del\u00e0 de l\'optimisation basique du rendement',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de RoomRaccoon vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration g\u00e8re le transfert complet des donn\u00e9es depuis RoomRaccoon, y compris les profils clients, l\'historique des r\u00e9servations, les plans tarifaires et les configurations de chambres. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans interruption.' },
    { question: 'HotelStack.io a-t-il des fonctionnalit\u00e9s IA comme RoomRaccoon ?', answer: 'Oui. HotelStack.io inclut la gestion intelligente du rendement, la pr\u00e9vision de la demande, les r\u00e8gles de tarification dynamique et les simulateurs de revenus. Nos outils IA vont au-del\u00e0 de l\'optimisation basique du rendement pour inclure la surveillance des concurrents et la planification de sc\u00e9narios hypoth\u00e9tiques.' },
    { question: 'HotelStack.io convient-il aux h\u00f4tels boutique comme RoomRaccoon ?', answer: 'Absolument. Notre plan Starter est con\u00e7u pour les \u00e9tablissements de toutes tailles, y compris les h\u00f4tels boutique. Vous obtenez les 36 modules d\u00e8s le premier jour sans restriction de fonctionnalit\u00e9s, et l\'interface luxe sombre moderne offre une exp\u00e9rience \u00e9l\u00e9gante que les \u00e9tablissements boutique appr\u00e9cient.' },
    { question: 'Comment HotelStack.io g\u00e8re-t-il le multi-\u00e9tablissements par rapport \u00e0 RoomRaccoon ?', answer: 'HotelStack.io inclut un tableau de bord complet de gestion de cha\u00eene avec analyses inter-\u00e9tablissements, distribution tarifaire centralis\u00e9e, standards de marque et rapports consolid\u00e9s. RoomRaccoon a un support multi-\u00e9tablissements limit\u00e9, faisant de HotelStack.io le meilleur choix pour les groupes h\u00f4teliers en croissance.' },
  ],
};

export const COMPARISON_FR_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_FR,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_FR,
  ...COMPARISON_FR_P3B,
};
